import { useAppFilterSelectedValue } from '../../../../hooks/filters/use-app-filter-selected-value.hook';
import { useAppFindFilter } from '../../../../hooks/filters/use-app-filters.hook';

import { FILTER_NAMES } from '../../hooks/filter-names.constants';
import { useFilterContext } from '../../provider/filter.provider';
import { PeriodSelectorComponent } from '../period-selector/period-selector.component';

interface FilterPaneTopComponentProps {
  reportId?: string;
  filterSelection: any;
  lastAvailableDate?: Date;
}

export const FilterPaneTopComponent = ({
  lastAvailableDate,
  filterSelection,
}: FilterPaneTopComponentProps) => {
  const filtersData = useFilterContext();
  const filter = useAppFindFilter(filtersData, FILTER_NAMES.DATE);

  const { setSelectedValue } = useAppFilterSelectedValue(FILTER_NAMES.DATEHIER);

  // Function to handle date range changes from the PeriodSelectorComponent
  const handleDateRangeChange = (
    startDate: Date,
    endDate: Date,
    dateView: string,
  ) => {
    // Update the DATEHIER filter with the appropriate Date View (Week, Month, Year)
    setSelectedValue({
      id: FILTER_NAMES.DATEHIER,
      values: [
        { value: dateView, label: dateView }, // Update the Date View filter based on the selection from PeriodSelectorComponent
      ],
    });
  };

  return (
    <>
      {filter && lastAvailableDate && (
        <PeriodSelectorComponent
          filter={filter}
          filterSelection={filterSelection}
          lastAvailableDate={lastAvailableDate}
          onApplyDateChange={handleDateRangeChange}
        />
      )}
    </>
  );
};
